export default __webpack_public_path__ + "static/media/IC00031-arrow_up.7ce27233.svg";